import React, { useState, useEffect } from "react";
import { Button, Form, Container, Row, Col, Alert } from "@themesberg/react-bootstrap";
import Base from "../base";
import { get, post, put } from "../../services/back.service";
import ListTables from "../../components/shared/tables";
import ModalMessage from "../../components/widgets/modalMessage";
import ModalCloseShift from "../../components/widgets/modalReportCloseShift";

const ShiftManager = () => {
  // State to hold shifts and form values
  const [shifts, setShifts] = useState([]);
  const [cashiers, setCashiers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [initialMoney, setInitialMoney] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [msgGet, setMsgGet] = useState("");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [showModalReport, setShowModalReport] = useState(false);
  const [selectedShift, setSelectedShift] = useState(false);

  // Add a new shift
  const handleAddShift = async () => {
    const userId = parseInt(selectedUserId);

    if (!userId || !initialMoney) return;

    const shift = {
      user_id: userId,
      initial_money: initialMoney
    };

    const createShift = await post('/cash/shifts/create/', shift, {})

    if (createShift.success) {
      setShifts([createShift.data, ...shifts]);
      setSelectedUserId("");
      setInitialMoney("");
      setErrorMessage("");
    } else {
      setErrorMessage(createShift.message);
    }
  };

  // Close a shift
  const editButton = (shift) => {
    if (shift.state !== 'close') {
      return (<Button
        variant="danger"
        onClick={() => { setSelectedShift(shift.id); setShowModalConfirm(true) }}
      >
        Cerrar
      </Button>)
    } else {
      return (<Button
        variant="success"
        onClick={() => { setSelectedShift(shift.id); setShowModalReport(true) }}
      >
        Reporte Cierre
      </Button>)
    }
  };

  const closeShift = async () => {
    const shift = {
      state: 'close'
    };

    const createShift = await put(`/cash/shifts/${selectedShift}/update/`, shift, {})

    if (createShift.success) {
      const newShifts = shifts.map((shift) => {
        if (shift.id === createShift.data.shift) return { ...shift, state: 'close' }
        return shift
      })
      setShowModalConfirm(false)
      setShifts(newShifts)
    } else {
      setErrorMessage(createShift.message);
    }
  }

  const getCashiers = async () => {
    const respoCashiers = await get('/cash/cashiers', {})
    if (respoCashiers.success) {
      const { users_data, shifts_data } = respoCashiers.data
      setCashiers(users_data);
      setShifts(shifts_data)
    } else {
      setMsgGet(respoCashiers.message)
    }
  }

  useEffect(() => {
    getCashiers()
  }, [])

  return (
    <Base>
      <Container>
        <Row className="mb-4">
          <Col>
            <h3>Create Shift</h3>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            <ModalMessage
              title={'Advertencia'}
              text={`Seguro desea cerrar el turno?`}
              showProps={showModalConfirm}
              funcAccept={closeShift}
              funcClose={() => setShowModalConfirm(false)}
            />
            <ModalCloseShift
              id={selectedShift}
              title={'Reporte Cierre'}
              showProps={showModalReport}
              funcClose={() => setShowModalReport(false)}
            />
            <Form>
              <Form.Group>
                <Form.Label>Seleccione Cajero</Form.Label>
                <Form.Select
                  value={selectedUserId}
                  onChange={(e) => setSelectedUserId(e.target.value)}
                >
                  <option value="">Seleccionar...</option>
                  {cashiers.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.first_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Monto Inicial</Form.Label>
                <Form.Control
                  type="number"
                  value={initialMoney}
                  onChange={(e) => setInitialMoney(e.target.value)}
                  placeholder="Enter initial money"
                />
              </Form.Group>

              <Button
                variant="primary"
                onClick={handleAddShift}
                className="mt-3"
                disabled={!selectedUserId || !initialMoney}
              >
                Create Shift
              </Button>
            </Form>
          </Col>
        </Row>

        <Row>
          <Col>
            <h3>Open Shifts</h3>
            <ListTables
              data={shifts}
              editar={editButton}
              messageWd={msgGet}
            />
          </Col>
        </Row>
      </Container>
    </Base>
  );
};

export default ShiftManager;
